import React, { useEffect, useState } from 'react'
import { Modal, Badge, Tooltip } from 'antd'
import { PushpinFilled } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import helpVideosData from './helpVideosData'
import helpVideosBundle from './helpVideosBundle'
import './SharelookHelpModal.scss'
import helpIcon from '../images/info.png'
import history from '../../../history'



const SharelookHelpModal = () => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const [activeVideo, setActiveVideo] = useState(null)
  const [activeTab, setActiveTab] = useState('videos')
  const [routeData, setRouteData] = useState({
    relevantVideos: [],
    releventBundle: [],
    isShowHelper: false
  })

  // Route detection and help videos logic
  useEffect(() => {
    const calculateRouteData = () => {
      const path = history.location.pathname.toLowerCase()
      const pathSegments = path.split('/').filter(Boolean)
      let routeKey = pathSegments[0] || 'default'
      let bundle = []
      if (routeKey === 'training' || pathSegments.length === 0) {
        routeKey = 'training'
      } else if (
        routeKey === 'course-create' ||
        routeKey === 'scorm-create' ||
        routeKey === 'courses' ||
        routeKey === 'course'
      ) {
        bundle = helpVideosBundle['courses']
        if (pathSegments.includes(`course-ai`)) {
          routeKey = 'coursesAi'
        } else if (pathSegments.includes(`page-constructor`)) {
          routeKey = 'coursesBuilder'
        } else {
          routeKey = 'courses'
        }
      } else if (routeKey === 'skill-journey') {
        routeKey = 'skillJourney'
      } else if (routeKey === 'share-sphere') {
        routeKey = 'trivia'
      } else if (routeKey === 'podcast-create') {
        routeKey = 'podcast'
      } else if (routeKey === 'workshop') {
        routeKey = 'workshop'
      }

      const videos = helpVideosData[routeKey] || []
      const shouldShow = videos && videos.length > 0

      setRouteData({
        relevantVideos: videos,
        releventBundle: bundle,
        isShowHelper: shouldShow
      })
    }

    calculateRouteData()
  }, [history.location.pathname])

  const { relevantVideos, releventBundle, isShowHelper } = routeData

  const isNewVideo = createdDate => {
    const videoDate = new Date(createdDate)
    const currentDate = new Date()
    const diffTime = Math.abs(currentDate - videoDate)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    return diffDays <= 7
  }

  const handleVideoSelect = video => {
    setActiveVideo(video)
  }

  const toggleModal = () => {
    setVisible(!visible)
  }

  const handleClose = () => {
    setVisible(false)
    setActiveVideo(null)
    setActiveTab('videos')
  }

  const hasBothSections = releventBundle.length > 0 && relevantVideos.length > 0

  if (!isShowHelper) {
    return null
  }

  return (
    <>
      <Tooltip title={t('v4:sharelook_help_center')}>
        <div className="helper_button" role="button" onClick={toggleModal}>
          <img alt="sharelook help" src={helpIcon} />
        </div>
      </Tooltip>

      <Modal
        visible={visible}
        onCancel={handleClose}
        footer={null}
        width={1024}
        className="sharelook-help-modal"
        title={t('v4:sharelook_help_center')}
        centered
      >
        <div className="help-modal-content">
          <div className="video-list-section">
            <h3 className="section-title">{t('v5:help_video')}</h3>

            <div className="sharelook-help-video-list">
              {hasBothSections && (
                <div className="help-video-tabs-container">
                  <div className="help-video-tabs">
                    <button
                      className={`tab-btn ${activeTab === 'videos' ? 'active' : ''
                        }`}
                      onClick={() => setActiveTab('videos')}
                    >
                      {t('v5:relevant_videos_label', {
                        defaultValue: 'Individual Videos'
                      })}
                    </button>
                    <button
                      className={`tab-btn ${activeTab === 'bundle' ? 'active' : ''
                        }`}
                      onClick={() => setActiveTab('bundle')}
                    >
                      {t('v5:pinned_bundle_label', {
                        defaultValue: 'Complete Tutorial'
                      })}
                    </button>
                  </div>
                </div>
              )}
              {(activeTab === 'videos' || !hasBothSections) &&
                relevantVideos.map((video, i) => (
                  <div
                    key={i}
                    className={`video-item ${activeVideo && activeVideo.id === video.id ? 'active' : ''
                      }`}
                    onClick={() => handleVideoSelect(video)}
                  >
                    <div className="video-item-content">
                      <h4 className="video-title">
                        {t(video.title)}
                        {isNewVideo(video.createdDate) && (
                          <Badge count="NEW" className="new-badge" />
                        )}
                      </h4>
                      <p className="video-description">
                        {t(video.description)}
                      </p>
                    </div>
                  </div>
                ))}

              {(activeTab === 'bundle' || !hasBothSections) &&
                releventBundle.length > 0 &&
                releventBundle.map((video, i) => (
                  <div
                    key={`bundle-${i}`}
                    className={`video-item ${activeVideo && activeVideo.id === video.id ? 'active' : ''
                      }`}
                    onClick={() => handleVideoSelect(video)}
                  >
                    <div className="video-item-content">
                      <h4 className="video-title">
                        {/* <span
                          className="video-pin-icon"
                          aria-hidden="true"
                          title={t('v5:pinned_bundle_label', {
                            defaultValue: 'Pinned bundle'
                          })}
                        >
                          <PushpinFilled />
                        </span> */}
                        {t(video.title)}
                        {isNewVideo(video.createdDate) && (
                          <Badge count="NEW" className="new-badge" />
                        )}
                      </h4>
                      <p className="video-description">
                        {t(video.description)}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>

          <div className="video-player-section">
            {activeVideo ? (
              <>
                <div className="video-header">
                  <h2 className="video-main-title">
                    {t(activeVideo.title)}
                    {isNewVideo(activeVideo.createdDate) && (
                      <Badge count="NEW" className="new-badge-large" />
                    )}
                  </h2>
                </div>
                <div className="video-player-wrapper">
                  <iframe
                    src={activeVideo.videoUrl}
                    title={t(activeVideo.title)}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="video-iframe"
                  ></iframe>
                </div>
                <div className="video-description-full">
                  <p>{t(activeVideo.description)}</p>
                </div>
              </>
            ) : (
              <div className="no-video-selected">
                <p>{t('v5:select_a_video_from_the_list')}</p>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </>
  )
}

export default SharelookHelpModal
